<!-- src/components/Icons/TrashIcon.vue -->
<template>
  <svg
    :class="['trash-icon', { hoverable }]"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
  >
    <path
      d="M10.9996 4.2V3.56C10.9996 2.66392 10.9996 2.21587 10.8252 1.87362C10.6718 1.57256 10.4271 1.32779 10.126 1.17439C9.78373 1 9.33569 1 8.43961 1H7.15961C6.26352 1 5.81548 1 5.47322 1.17439C5.17217 1.32779 4.9274 1.57256 4.774 1.87362C4.59961 2.21587 4.59961 2.66392 4.59961 3.56V4.2M6.19961 8.6V12.6M9.39961 8.6V12.6M0.599609 4.2H14.9996M13.3996 4.2V13.16C13.3996 14.5041 13.3996 15.1762 13.138 15.6896C12.9079 16.1412 12.5408 16.5083 12.0892 16.7384C11.5758 17 10.9037 17 9.55961 17H6.03961C4.69548 17 4.02342 17 3.51003 16.7384C3.05844 16.5083 2.69129 16.1412 2.46119 15.6896C2.19961 15.1762 2.19961 14.5041 2.19961 13.16V4.2"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  hoverable: {
    type: Boolean,
    default: true,
  },
});
</script>

<style scoped>
.trash-icon {
  color: #666666;
  transition: color 0.3s ease;
  cursor: pointer;
}

.trash-icon.hoverable:hover {
  color: #d32f2f;
}
</style>
